import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { FilterValue } from 'antd/es/table/interface';
import { AccessRule, ActionFromPayloadMap } from '../config/types';
import AccessRuleReducer from '../reducers/accessRules';

export type AccessRuleStateType = {
  accessRulesKeyedById: Map<string, AccessRule>
  isFetchingAccessRules: boolean
  isCreatingNewAccessRule: boolean
  isUpdatingAccessRule: boolean
  accessRulesImportCreatedCount: number
  accessRulesImportUpdatedCount: number
  searchAccessRules: string | null
  filtersAccessRulesTable: Record<string, FilterValue | null>
};

const initialState: AccessRuleStateType = {
  accessRulesKeyedById: new Map(),
  searchAccessRules: null,
  isFetchingAccessRules: false,
  isCreatingNewAccessRule: false,
  accessRulesImportUpdatedCount: 0,
  accessRulesImportCreatedCount: 0,
  isUpdatingAccessRule: false,
  filtersAccessRulesTable: {},
};

export type AccessRuleActionPayloadMap = {
  SET_ACCESS_RULE: AccessRule;
  SET_ACCESS_RULES: Map<string, AccessRule>;
  SET_FETCHING_ACCESS_RULES: boolean;
  SET_CREATING_NEW_ACCESS_RULE_LOADING: boolean;
  SET_UPDATING_ACCESS_RULE_LOADING: boolean;
  SET_ACCESS_RULES_IMPORT_CREATED_COUNT: number;
  SET_ACCESS_RULES_IMPORT_UPDATED_COUNT: number;
  SET_SEARCH_ACCESS_RULES: string;
  SET_FILTERS_ACCESS_RULES_TABLE: Record<string, FilterValue | null>;
};

export type AccessRuleAction = ActionFromPayloadMap<AccessRuleActionPayloadMap>;

export const AccessRuleContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<AccessRuleAction>,
});

export const useAccessRule = (): [AccessRuleStateType, React.Dispatch<AccessRuleAction>] => {
  const { state, dispatch } = useContext(AccessRuleContext);
  return [state, dispatch];
};

export const AccessRuleProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(AccessRuleReducer, initialState);

  return (
    <AccessRuleContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </AccessRuleContext.Provider>
  );
};
